import { useState } from "react";

function CarBox({ data, carID }) {
  const [carLoad, setCarLoad] = useState(true);
  return (
    <>
      {data[carID].map((car, id) => (
        <div key={id} className="box-cars">
          {/* car */}
          <div className="pick-car">
            {carLoad && <span className="loader"></span>}
            <img
              style={{ display: carLoad ? "none" : "block" }}
              src={car.img}
              alt="car_img"
              onLoad={() => setCarLoad(false)}
            />
          </div>
          {/* description */}
          <div className="pick-description">
            <div className="pick-description__price">
              <span>{car.price}</span>
            </div>
            <div className="pick-description__table">
              <div className="pick-description__table__col">
                <span>Capacity</span>
                <span>{car.capacity}</span>
              </div>

              <div className="pick-description__table__col">
                <span>Bags</span>
                <span>{car.bags}</span>
              </div>

              <div className="pick-description__table__col">
                <span>Ac</span>
                <span>{car.ac}</span>
              </div>
              <div className="pick-description__table__col">
                <span>Fuel</span>
                <span>{car.fuel}</span>
              </div>
            </div>
            {/* btn cta */}
            <a className="cta-btn" href="tel:+91 9324064780">
              Reserve Now
            </a>
          </div>
        </div>
      ))}
    </>
  );
}

export default CarBox;
